/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePriceDto
 */
export interface CreateUpdatePriceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePriceDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePriceDto
     */
    consultationType?: CreateUpdatePriceDtoConsultationTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePriceDto
     */
    supportingExaminationDictId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePriceDto
     */
    pricingGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePriceDto
     */
    articleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePriceDto
     */
    price?: string | null;
}


/**
 * @export
 */
export const CreateUpdatePriceDtoConsultationTypeEnum = {
    Neurological: 'Neurological',
    Ophthalmologist: 'Ophthalmologist',
    ENT: 'ENT',
    Psychiatric: 'Psychiatric'
} as const;
export type CreateUpdatePriceDtoConsultationTypeEnum = typeof CreateUpdatePriceDtoConsultationTypeEnum[keyof typeof CreateUpdatePriceDtoConsultationTypeEnum];


/**
 * Check if a given object implements the CreateUpdatePriceDto interface.
 */
export function instanceOfCreateUpdatePriceDto(value: object): value is CreateUpdatePriceDto {
    return true;
}

export function CreateUpdatePriceDtoFromJSON(json: any): CreateUpdatePriceDto {
    return CreateUpdatePriceDtoFromJSONTyped(json, false);
}

export function CreateUpdatePriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePriceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'consultationType': json['consultationType'] == null ? undefined : json['consultationType'],
        'supportingExaminationDictId': json['supportingExaminationDictId'] == null ? undefined : json['supportingExaminationDictId'],
        'pricingGroupId': json['pricingGroupId'] == null ? undefined : json['pricingGroupId'],
        'articleId': json['articleId'] == null ? undefined : json['articleId'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function CreateUpdatePriceDtoToJSON(value?: CreateUpdatePriceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'consultationType': value['consultationType'],
        'supportingExaminationDictId': value['supportingExaminationDictId'],
        'pricingGroupId': value['pricingGroupId'],
        'articleId': value['articleId'],
        'price': value['price'],
    };
}

